import module from 'colaborador/module.js'
import template from './template.html'

export class ColaboradorIncapacidadesListaComponent {
  data
  onChange
  eliminando = false
  confirmarEliminar = null
  editando = null
  filtro = ''

  constructor ($filter) {
    this.filterBy = $filter('filter')
    this.orderBy = $filter('orderBy')
  }

  $onChanges (changes) {
    if (changes.data) {
      this.data = this.orderBy(changes.data.currentValue, ['-fecha_inicial'])
      this.filtrar()
    }
  }

  actualizar (item, data) {
    this.data.splice(this.data.indexOf(item), 1, Object.assign({}, data))
    this.data = [...this.data]
    this.onChange({$event: {detail: this.data}})
  }

  eliminar (item) {
    this.data.splice(this.data.indexOf(item), 1)
    this.data = [...this.data]
    this.onChange({$event: {detail: this.data}})
  }

  filtrar () {
    this.resultados = this.filterBy(this.data, this.filtro)
  }
}

module.component('colaboradorIncapacidadesLista', {
  controller: ColaboradorIncapacidadesListaComponent,
  template,
  bindings: {
    data: '<',
    onChange: '&',
  },
})



// WEBPACK FOOTER //
// ./src/colaborador/components/incapacidades/lista/component.js